
export const updateSelectedCategory = (data) => {
    return (dispatch, getState) => {
        if (data) {
            dispatch({ type: 'selectedCategory', selectedCategory: data })
        } else {
            // Clearing the category means "show everything", not "show Carros" —
            // this used to reset to 1 (Carros), which made it impossible to ever
            // get back to the unfiltered home feed once a category was picked.
            dispatch({ type: "selectedCategory", selectedCategory: null });
        }
    }
}